<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1000px"
      title="学生列表"
      id-key="GroupId"
      :data="data"
      form-label-width="80px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      @create-opened="onCreateOpened"
      @details-opened="onDetailsOpened"
      :before-save="onBeforeSave"
      @close-saved="$emit('close-saved')"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <student-list ref="studentList">
              <template slot="toolbar-right" v-if="!isMB">
                <el-button size="mini" class="filter-item" @click="importFile" type="success" plain v-if="!isMB">导入</el-button>
                <el-button size="small" class="filter-item" @click="onExport" type="primary" plain>导出</el-button>
              </template>
            </student-list>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <el-button @click="close(true)">关 闭</el-button>
      </template>
    </common-dialog>
    <import-dialog ref="importDialog" @upload-success="reload2" />
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import studentList from './studentList';
import importDialog from "@/components/st/group/importDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    studentList,importDialog
  },
  data() {
    return {
      data: {
        GroupId: 0,
      },
      isMB: this.$store.state.isMB,
      api: require("@/api/st/groupStudent").default,
      rules: {
        
      },
    };
  },
  methods: {
    onCreateOpened() {
    },
    onDetailsOpened(data) {
      this.$refs.studentList.getData({ GroupId: data.GroupId });
    },
    onExport() {
      this.$refs.studentList.export();
    },
    onBeforeSave() {

    },
    onClosed() {
      
    },
    importFile() {
      this.$refs.importDialog.open({ GroupId: this.data.GroupId });
    },
    reload2(){
      this.$refs.studentList.reload()
    }
  }
};
</script>